exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span i[data-v-0951af0c]{color:#70697a!important;font-size:12px!important}", ""]);

// exports
